export type WalletAccountStatus = "ACTIVE" | "SUSPENDED" | "CLOSED";

/** ສະຖານະບັນຊີ wallet ເປັນພາສາລາວ (ສຳລັບແສງໃນ UI) */
export const WALLET_STATUS_LABELS_LAO: Record<WalletAccountStatus, string> = {
  ACTIVE: "ໃຊ້ງານ",
  SUSPENDED: "ຕັ້ງລະງັບ",
  CLOSED: "ປິດ",
};

/** Row for Wallet accounts list */
export type WalletAccountListRow = {
  id: string;
  customerId: string;
  customerName: string | null;
  customerPhone: string;
  status: WalletAccountStatus;
  balanceLak: number;
  createdAt: string;
};

export type TopupMethod = "CASHIER" | "BANK_SLIP";

export type TopupRequestStatus = "PENDING" | "APPROVED" | "REJECTED";

/** Row for Top-up approval queue list */
export type TopupQueueRow = {
  id: string;
  walletAccountId: string;
  customerName: string | null;
  customerPhone: string;
  method: TopupMethod;
  amountLak: number;
  requestedAt: string;
  slipUrl: string | null;
  status: TopupRequestStatus;
  reviewedAt: string | null;
  /** Set when counter top-up completed via POS QR session */
  sourceSessionId: string | null;
  walletTransactionId: string | null;
};

/** Row for Refund approval queue list */
export type RefundQueueRow = {
  id: string;
  orderId: string;
  orderNo: string;
  walletAccountId: string;
  customerName: string | null;
  customerPhone: string;
  amountLak: number;
  reason: string | null;
  createdAt: string;
  status: "PENDING" | "APPROVED" | "REJECTED";
};

export type LedgerTransactionType =
  | "TOPUP"
  | "PAYMENT"
  | "REFUND"
  | "ADJUSTMENT";

/** Row for Ledger explorer list (from wallet_ledger_entries + txn + customer) */
export type LedgerEntryRow = {
  id: string;
  walletAccountId: string;
  txnId: string;
  customerName: string | null;
  customerPhone: string;
  type: LedgerTransactionType;
  direction: "CREDIT" | "DEBIT";
  amountLak: number;
  balanceAfterLak: number;
  refOrderId: string | null;
  orderNo: string | null;
  status: string;
  createdAt: string;
};

/** ຂໍ້ມູນວົງເງິນຕໍ່ບັນຊີ (ສຳລັບໜ້າຕັ້ງວົງເງິນ) */
export type WalletLimitsView = {
  walletId: string;
  balanceLak: number;
  customerName: string | null;
  customerPhone: string;
  dailyTopupLimit: number | null;
  dailySpendLimit: number | null;
  maxBalance: number | null;
  requireApprovalOverLak: number | null;
};

/** Payload สำหรับอัปเดต wallet_limits (ค่า ≥ 0 หรือ null) */
export type WalletLimitsUpdatePayload = {
  dailyTopupLimit?: number | null;
  dailySpendLimit?: number | null;
  maxBalance?: number | null;
  requireApprovalOverLak?: number | null;
};
